export const presenceSelectors = [
    { value: 1, label: "в наявності" },
    { value: 0, label: "відсутні на складі" },
    { value: "", label: "всі товари" },
];

export const sortSelectors = [
    { value: ["id", "desc"], label: "по даті: нові спочатку" },
    { value: ["id", "asc"], label: "по даті: старі спочатку" },
    { value: ["title", "asc"], label: "по назві: від А до Я" },
    { value: ["title", "desc"], label: "по назві: від Я до А" },
    { value: ["price", "asc"], label: "по ціні: від більшої" },
    { value: ["price", "desc"], label: "по ціні: від меншої" },
];

export const filterSelectors = [
    { value: "without_price_stock_usd", label: "без закупки" },
    { value: "without_mpn", label: "без MPN" },
    // { value: 'vanilla', label: 'Проблемні IMEI' },
];
